import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const PREAUTH_CAPTURE: PaymentMethod = {
    id: PAYMENT_METHOD_ID.PreauthCapture,
    name: 'preauthcapture',
    tokenRequired: true
};
